import { MyAPIList } from '@/api'

const api = new MyAPIList();

export default {

  getCustomer({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getCustomer(params, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        resolve(json);
      }, (error) => {
        reject(error);
      })
    })
  },

  getProfile({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getAgent(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        resolve(json);
      }, (error) => {
        reject(error);
      })
    })
  },

  editPreference({ state }, param) {
    return new Promise((resolve, reject) => {
      api.editPreference(param, (json) => {
        resolve(json);
      }, (error) => {
        reject(error);
      })
    })
  },

  changePassword({ state }, param) {
    return new Promise((resolve, reject) => {
      api.changePassword(param, (json) => {
        resolve(json);
      }, (error) => {
        reject(error);
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/My/store/actions.js